<template>
  <b-form-group>
    <template v-for="(comp, index) in this.internalFormComponents" :key="comp.uniqueTitle">
      <div v-if="comp.needsFieldSpacing" class="mb-4">
        <component
          :is="comp"
          v-if="comp"
          v-bind:uniqueTitle="comp.uniqueTitle"
          v-bind:formComponents="comp.formComponents"
          v-bind:placeholder="comp.placeholder"
          v-bind:fieldLabel="comp.fieldLabel"
          v-bind:description="comp.description"
          v-bind:checkedDescription="comp.checkedDescription"
          v-bind:choices="comp.choices"
          v-bind:displayStyle="comp.displayStyle"
          v-bind:selectionMode="comp.selectionMode"
        />
        <FormFieldDescription :description="comp.description" :description-id="comp.description ? comp.uniqueTitle + '-description' : ''" />
      </div>
      <template v-else>
        <component
          :is="comp"
          v-if="comp"
          v-bind:uniqueTitle="comp.uniqueTitle"
          v-bind:formComponents="comp.formComponents"
          v-bind:placeholder="comp.placeholder"
          v-bind:fieldLabel="comp.fieldLabel"
          v-bind:description="comp.description"
          v-bind:checkedDescription="comp.checkedDescription"
          v-bind:choices="comp.choices"
          v-bind:displayStyle="comp.displayStyle"
          v-bind:selectionMode="comp.selectionMode"
        />
        <FormFieldDescription :description="comp.description" :description-id="comp.description ? comp.uniqueTitle + '-description' : ''" />
      </template>
    </template>
  </b-form-group>
</template>

<script>

import { markRaw } from 'vue'
import _ from 'lodash'
import FormRow from './formrow2.vue'
import FormFieldDescription from '../FormFieldDescription.vue'
import { formControlMap, applyFormControlProps } from './form-controls'

const inputMap = {
  ...formControlMap,
  formRow: FormRow
}

export default {
  components: {
    FormFieldDescription
  },
  props: ['formComponents'],
  data() {
    return {
      internalFormComponents: []
    }
  },
  watch: {
    formComponents: {
      immediate: true,
      handler: function () {

        this.internalFormComponents = []

        if (!this.formComponents) {

          console.log(`formgroup handler called, but no formComponents are present`)
          console.log(this)

          return
        }

        let noUniqueTitleCounter = 0

        for (let component of this.formComponents) {

          console.log(`formgroup adding component ${component.type}`)
          console.log(component)

          let instantiatedComponent = _.cloneDeep(inputMap[component.type])

          console.log(instantiatedComponent)

          if (!instantiatedComponent) {

            console.warn(`formgroup skipping unknown component type ${component.type}`)
            continue
          }

          if (!component.uniqueTitle) {

            component.uniqueTitle = `component_without_unique_title_${noUniqueTitleCounter++}`
          }

          instantiatedComponent.uniqueTitle = component.uniqueTitle

          applyFormControlProps(instantiatedComponent, component, { spaceDirectInputs: true })

          if (component.components) {

            console.log(`${instantiatedComponent.uniqueTitle} with ${component.components.length} child components`)
          }

          this.internalFormComponents.push(markRaw(instantiatedComponent))
        }
      }
    }
  }
}
</script>